/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import { OrderTracking } from './models/order-tracking';
import { ApiService } from './api.service';
import i18n from './getText';

export class StoreService {

  trackingNumber: string = null;
  orderTracking: OrderTracking = new OrderTracking();
  loaded: boolean = false;
  customerSelectedAddress: boolean = false;

  constructor() {
    this.trackingNumber = window.location.pathname.split('/').slice(-1)[0]
      || window.location.search.replace('?t=', '');


  }

  setDataForLuckyOrange(orderTracking: OrderTracking) {

    const customData = {
      'order': orderTracking.number,
      'trackingNumber': this.trackingNumber
    };

    window['_loq'] = window['_loq'] || [];
    window['_loq'].push(['custom', customData]);

  }

  private getOrderWrapper(trackingNumber: string) {
    const orderTrackingSource = localStorage.getItem('orderTracking_' + trackingNumber);
    let orderTracking = null;
    try {
      orderTracking = JSON.parse(orderTrackingSource);
    // tslint:disable-next-line:no-empty
    } catch (e) {
    }

    if (orderTracking) {
      return Promise.resolve(orderTracking);
    }
    return ApiService.getOrderByTrackingOrderNumber(trackingNumber);

  }

  load(): Promise<any> {

    if (this.loaded) {
      return Promise.resolve(this.orderTracking);
    }

    return this.getOrderWrapper(this.trackingNumber)
      .then(result => {
        this.loaded = true;
        Object.assign(this.orderTracking, result);
        this.setDataForLuckyOrange(result);
        return this.orderTracking;
      })
      .catch(error => {
        this.loaded = false;
        return Promise.reject({
          error: true,
          message: i18n.pgettext('OrderTrackingPage', 'Order not found')
        });
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/store.service.ts